(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentReport', IncidentReport);

    IncidentReport.$inject = ['$resource', 'DateUtils'];

    function IncidentReport ($resource, DateUtils) {
        var resourceUrl =  'api/incident-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'autoSave': {url: 'api/incident-reports/auto-save', method: 'POST', ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'sign': { method: 'POST', url: 'api/incident-reports/sign'},
            'getSignatures': { url: 'api/incident-reports/signatures/:id', method: 'GET', isArray: true},
            'findAllByFilter': {url: 'api/incident-reports/filter', method: 'GET', isArray: true}
        });
    }
})();
